import * as ACTION_TYPES from "../actions/action_types";

export const initialState = {
  offer: "NoOffer",
};

export const OfferReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.SET_OFFER:
      return {
        ...state,
        offer: action.payload,
      };
    case ACTION_TYPES.FAILURE:
      return {
        ...state,
        offer: "FAILURE",
      };
    default:
      return state;
  }
};
